import { ao as h, ap as F, a as d, m as b, q as S, u as k, o as q, b as w, c as f, e as v, g as $, t as I, k as V, z as D, aD as E, G as C, x as R, j as z, n as A, an as G } from "./define-element-XpjsV6s1.js";
import { i as s, b as N } from "./utils-CMsllPx8.js";
import { _ as P } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const T = ["aria-invalid", "aria-describedby"], _ = ["id"], j = {
  __name: "Input",
  props: /* @__PURE__ */ G({
    floating: {
      type: Boolean,
      default: !1
    },
    invalid: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(m) {
    const e = h(m, "modelValue"), l = "input-" + Math.random().toString(36).substring(2), n = m, p = F(), r = d(!1), c = d(!1), o = d(!1), g = b(() => p.type === "email" && !s(e.value) && !N(e.value)), i = b(() => n.invalid && s(e.value) || r.value && c.value && g.value ? !1 : r.value && p.required != null ? !s(e.value) : !0);
    function B() {
      c.value = !0, s(e.value) && (o.value = !1);
    }
    function y() {
      s(e.value) || (o.value = !0);
    }
    S(
      () => e.value,
      () => {
        n.floating && y();
      }
    );
    const M = k("container");
    return q(() => {
      w(M.value), y();
    }), (t, a) => (f(), v("div", {
      ref: "container",
      class: A([
        "offset-input",
        t.$attrs.required ? "required" : "",
        i.value ? "" : "invalid",
        n.floating ? "floating" : "",
        o.value ? "is-floating" : ""
      ])
    }, [
      t.$attrs.label ? (f(), v("label", {
        key: 0,
        for: l
      }, [
        $("span", null, I(t.$attrs.label), 1)
      ])) : V("", !0),
      D($("input", C(t.$attrs, {
        id: l,
        "onUpdate:modelValue": a[0] || (a[0] = (u) => e.value = u),
        "aria-invalid": !i.value,
        "aria-describedby": i.value ? void 0 : `${l}-error`,
        onInput: a[1] || (a[1] = R((u) => r.value = !0, ["stop"])),
        onFocusin: a[2] || (a[2] = (u) => o.value = !0),
        onFocusout: B
      }), null, 16, T), [
        [E, e.value]
      ]),
      i.value ? V("", !0) : (f(), v("div", {
        key: 1,
        id: `${l}-error`,
        class: "error",
        role: "alert"
      }, I(g.value ? "Please enter a valid email address" : "This field is required"), 9, _)),
      z(t.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}, J = /* @__PURE__ */ P(j, [["__scopeId", "data-v-11244387"]]);
export {
  J as I
};
